import { User } from "~/common/Store/connectUserAndChat";
import getLowestPrice from "~/common/Product/getLowestDisplayPrice";
import { Price } from "~/ProductDetails/ProductDetailPageResult";

// Used to calculate the divide by quantityPerPackaging based on product quantity amount for product variations and breakdown quantity tiles.
export const calculateDivideByQuantityAndPrice = (
  tileData: {
    quantityPerPackaging: number;
    price: Price | null;
    unitOfMeasurement: string;
    itemNumber: string;
    showBelowMinimumAdvertisedPriceForLoggedInCustomers: boolean;
    showBelowMinimumAdvertisedPriceForPlatinumAndPlusCustomers: boolean;
  }[],
  user: User,
) => {
  const minQuantityItems = tileData.reduce((minItem, currentItem) => {
    return currentItem.quantityPerPackaging < minItem.quantityPerPackaging
      ? currentItem
      : minItem;
  });

  let minUnit = minQuantityItems.unitOfMeasurement;
  const minQuantity = minQuantityItems.quantityPerPackaging;

  if (minUnit?.toLowerCase() === "sample") {
    minUnit = "Each";
  }

  const results = tileData
    .filter((item) => item.quantityPerPackaging !== minQuantity)
    .map((item) => {
      const dividedQuantityPerPackaging =
        item.quantityPerPackaging / minQuantity;

      const lowestPrice =
        item.price &&
        getLowestPrice(
          {
            showBelowMinimumAdvertisedPriceForLoggedInCustomers:
              item.showBelowMinimumAdvertisedPriceForLoggedInCustomers,
            showBelowMinimumAdvertisedPriceForPlatinumAndPlusCustomers:
              item.showBelowMinimumAdvertisedPriceForPlatinumAndPlusCustomers,
            price: item.price,
          },
          user,
          false,
        );

      const divideByPricePerPackaging =
        lowestPrice !== null && dividedQuantityPerPackaging > 0
          ? lowestPrice / dividedQuantityPerPackaging
          : null;

      return {
        itemNumber: item.itemNumber,
        divideByLowestQuantity: divideByPricePerPackaging,
        minUnit,
      };
    });
  return results;
};

export const getDivideByQuantityPricePerPackagingItem = (
  tileData: {
    quantityPerPackaging: number;
    price: Price | null;
    unitOfMeasurement: string;
    itemNumber: string;
    showBelowMinimumAdvertisedPriceForLoggedInCustomers: boolean;
    showBelowMinimumAdvertisedPriceForPlatinumAndPlusCustomers: boolean;
  }[],
  itemNumber: string,
  user: User,
) => {
  return calculateDivideByQuantityAndPrice(tileData, user).filter(
    (item) => item.itemNumber === itemNumber,
  );
};
